module.exports = __webpack_public_path__ + "static/img/cover@2x.c21fbae7.jpeg";